exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.stars, span.stars span {\r\n    display: block;\r\n   /* Download the star image here: http://stackoverflow.com/questions/1987524/turn-a-number-into-star-rating-display-using-jquery-and-css */\r\n    background: url('https://apppresser.com/wp-content/uploads/2015/11/stars.png') 0 -16px repeat-x;\r\n    width: 80px;\r\n    height: 16px;\r\n  }\r\n  \r\n  span.stars span {\r\n    background-position: 0 0;\r\n  }\r\n\r\n  table {\r\n    border-collapse: collapse;\r\n  }\r\n  \r\n  table, td, th {\r\n    border: 1px solid black;\r\n  }\r\n  th, td {\r\n    padding: 10px;\r\n    text-align: left;\r\n  }\r\n  ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/phoneinfo2/phoneinfo/src/app/components/compare/compare.component.css
// module id = ../../../../../src/app/components/compare/compare.component.css
// module chunks = main